import React, { useLayoutEffect, useRef } from 'react';
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

function ProcessGraph({ graphData }) {
    const chartElementRef = useRef(null);


    useLayoutEffect(() => {
        if (graphData && Object.keys(graphData).length > 0) { 
            let chart = am4core.create(chartElementRef.current, am4charts.XYChart);
    
            chart.data = [
                {
                    category: 'Хөтөлбөр оруулсан сувгийн тоо',
                    value: graphData.foundEpgChannelsCount || 0,
                    foundEpgChannels: graphData.foundEpgChannels || []
                },
                {
                    category: 'Хөтөлбөр нийтлэгдсэн сувгийн тоо',
                    value: graphData.executedEpgChannelsCount || 0,
                    foundEpgChannels: graphData.executedEpgChannels || []
                },
                {
                    category: 'Хөтөлбөр ороогүй сувгийн тоо',
                    value: graphData.notFoundEpgChannelsCount || 0,
                    foundEpgChannels: graphData.notFoundEpgChannels || []
                },
            ];
    
            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "category";
            categoryAxis.renderer.grid.template.location = 0;
    
            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.max = graphData.allActiveChannel || 0;
            valueAxis.title.text = "Бүх идэвхтэй сувгийн тоо";
    
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = "value";
            series.dataFields.categoryX = "category";
            series.name = "Value";
            series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
    
            series.columns.template.adapter.add("fill", (fill, target) => {
                switch (target.dataItem.categoryX) {
                    case 'Хөтөлбөр оруулсан сувгийн тоо':
                        return am4core.color("#f7dc6f");
                    case 'Хөтөлбөр ороогүй сувгийн тоо':
                        return am4core.color("#f1948a");
                    case 'Хөтөлбөр нийтлэгдсэн сувгийн тоо':
                        return am4core.color("#58d68d");
                    default:
                        return fill;
                }
            });
    
            series.columns.template.adapter.add("tooltipHTML", (html, target) => {
                let item = target.dataItem?.dataContext;
                if (item && item.foundEpgChannels) {
                    let channelNames = item.foundEpgChannels.map(channel => `<div>${channel.name}</div>`).join('');
                    return `<b>${item.category}</b>: ${item.value}<br>${channelNames}`;
                }
                return html;
            });
    
            let columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;
    
            return () => {
                chart.dispose();
            };
        }
    }, [graphData]);

    
    return (
        <div id="chartdiv" ref={chartElementRef} style={{ width: "100%", height: "500px" }}></div>
    );
}
export default ProcessGraph;
